/**
 * Toast Management for IronHUD (Alpine.js Component)
 */

export const ToastComponent = () => ({
    toasts: [],

    init() {
        window.addEventListener('gym:toast', (e) => {
            this.add(e.detail.message, e.detail.type || 'info', e.detail.duration || 5000);
        });

        // Personal Record celebration
        window.addEventListener('gym:prSet', (e) => {
            const { exercise, value, unit } = e.detail;
            this.add(`🏆 PR — ${exercise}: ${value}${unit}`, 'pr', 6000);
        });

        // Expose toast API globally for JS components
        window.toasts = this;
    },

    add(message, type = 'info', duration = 5000) {
        const id = Date.now() + Math.random();
        const config = this.getTypeConfig(type);

        this.toasts.push({
            id,
            message,
            type,
            config,
            visible: false,
        });

        // Trigger animation in next tick
        setTimeout(() => {
            const index = this.toasts.findIndex((t) => t.id === id);
            if (index !== -1) this.toasts[index].visible = true;
        }, 10);

        // Auto-dismiss
        if (duration > 0) {
            setTimeout(() => this.dismiss(id), duration);
        }
    },

    dismiss(id) {
        const index = this.toasts.findIndex((t) => t.id === id);
        if (index !== -1) {
            this.toasts[index].visible = false;
            // Wait for transition before removal
            setTimeout(() => {
                this.toasts = this.toasts.filter((t) => t.id !== id);
            }, 300);
        }
    },

    getTypeConfig(type) {
        const configs = {
            success: {
                bg: 'toast-gym-success',
                icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
            },
            error: {
                bg: 'toast-gym-error',
                icon: 'M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
            },
            info: {
                bg: 'toast-gym-info',
                icon: 'M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
            },
            pr: {
                bg: 'toast-gym-base bg-strength-surface border-white/10 text-white',
                icon: 'M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z',
            },
        };
        return configs[type] || configs.info;
    },
});
